import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Pendencia {
  descricao: string;
  acao?: string;
  link?: string;
  download?: boolean;
}

@Component({
  selector: 'app-pendencias-list',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="pendencias-list">
      <h4>Pendências</h4>
      <ul>
        <li *ngFor="let p of pendencias">
          <span>{{ p.descricao }}</span>
          <a *ngIf="p.link" [href]="p.link">{{ p.acao }}</a>
          <button *ngIf="p.download" (click)="baixarGuia.emit(p)">Baixar Guia</button>
        </li>
      </ul>
    </div>
  `,
  styleUrls: ['./pendencias-list.component.scss']
})
export class PendenciasListComponent {
  @Input() pendencias: Pendencia[] = [];
  @Output() baixarGuia = new EventEmitter<Pendencia>();
} 